import React, { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.heat/dist/leaflet-heat.js";
import { getVisitorsLocations } from "../../backendServices/visitorLocationService";

const CustomerHeatmap = ({ token }) => {
  const [map, setMap] = useState(null); // Track map instance
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      // window.location.reload();
      try {
        const response = await getVisitorsLocations(token);
        //   const data = await response?.data?.json();
        console.log("locations => : ", response.data);
        setLocations(response.data);
      } catch (error) {
        console.error("Failed to fetch locations", error);
      }
    };

    fetchLocations();
  }, [token]);

  useEffect(() => {
    if (locations.length > 0) {
      let currentMap = map;

      // If map instance doesn't exist, create a new one
      if (!currentMap) {
        currentMap = L.map("map", {
          center: [30.0131, 31.2089], // Default center
          zoom: 7,
        });

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
          currentMap
        );

        setMap(currentMap); // Save map instance
      }

      // Remove existing heatmap layer (if any)
      currentMap.eachLayer((layer) => {
        if (layer instanceof L.HeatLayer) {
          currentMap.removeLayer(layer);
        }
      });

      // Prepare heatmap data
      const heatmapData = locations.map((location) => [
        location.latitude,
        location.longitude,
      ]);

      // Add heatmap layer
      L.heatLayer(heatmapData, { radius: 25, blur: 13, maxZoom: 16 }).addTo(
        currentMap
      );
    }

    // Cleanup map instance on component unmount
    return () => {
      if (map) {
        map.remove();
        setMap(null);
      }
    };
  }, [locations, map]);

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {/* // <div> */}
      <h2 style={{ margin: "70px 50px 30px 50px" }}>
        Customer Density Heatmap
      </h2>
      <div id="map" style={{ height: "80%", width: "100%" }}></div>
    </div>
  );
};

export default CustomerHeatmap;
